export interface AppConfig {
  readonly auth: {
    isWalletAllowed: boolean
    isSignUpByEmailAllowed: boolean
    isTwitterAllowed: boolean
    isDiscordAllowed: boolean
    isAuthRequired: boolean
    isReferralCodeFlowAllowed: boolean
  }
  readonly tokenMintAllowed: boolean
  readonly isMainNetFeature: boolean
  readonly demoUpDownAi: boolean
  /** Bullseye leaderboard block (DEV-147): boards, realtime, history, the rank row. */
  readonly bullsEyeLeaderboard: boolean
  /** FE-320: report repeat visits via `touchAttribution`; needs BE-311 on the gateway. */
  readonly attributionTouch: boolean
  /** FE-330: report the cookie choice via `setConsent`; needs BE-342 on the gateway. */
  readonly consentSync: boolean
  readonly mobile: {
    upDown: boolean
    oneVsOne: boolean
    bullsEye: boolean
    setups: boolean
    rewards: boolean
  }
}

export enum Stand {
  beta = 'beta',
  dev = 'dev',
  prod = 'prod',
  mainnet = 'mainnet'
}
